export function createMarketplaceEventFactory(namespace, eventName) {
  return function (eventProps) {
    return {
      namespace,
      eventName,
      eventProps
    };
  };
}